export default {
  Role: "บทบาท",
  action: "action",
  activation_date: "Activation date",
  active: "active",
  add: "เพิ่ม",
  addAlbumName: "เพิ่มชื่ออัลบั้ม",
  addSelectedToClaimList: "เพิ่มในพื้นที่อ้างสิทธิ์",
  addedToClaimList: "Added to Claim List",
  additional_data: "additional data",
  additions_pct: "ยอดรวมการหัก(%)",
  address: "ที่อยู่",
  agent: "agent",
  airdatetime: "เวลาออกอากาศ",
  all_fields_must_be_filled: "ต้องกรอกข้อมูลทุกช่อง!",
  artist: "ศิลปิน",
  auto_manually_matched: "auto manually matched",
  automatched: "automatched",
  automatchedCheckboxInfo: "Select this to re-match the already matched usages as well (manual matches won’t be re-matched).",
  blocked: "blocked",
  cancel: "ยกเลิก",
  chooseFileOrDrag: "เลือกไฟล์ หรือ ลากไฟล์มาตรงนี้",
  choose_mandates_before_activation: "Please choose mandates before activating user",
  claim: "อ้างสิทธิ์",
  claimAll: "อ้างสิทธิ์ทั้งหมด",
  claimPercentage: "claim %",
  claimStatus: "สถานะการอ้างสิทธิ์",
  claimWorkspace: "พื้นที่อ้างสิทธิ์",
  claim_edited: "แก้ไขการอ้างสิทธิ์สำเร็จ",
  claimed: "อ้างสิทธิ์แล้ว",
  claiming: "กำลังดำเนินการอ้างสิทธิ์",
  claims: "การอ้างสิทธิ์",
  clear: "clear",
  clearFilters: "ยกเลิกตัวกรองข้อมูล",
  clear_all: "clear all",
  collapse: "collapse",
  companyName: "ชื่อบริษัท",
  company_profile: "ประวัติข้อมูลบริษัท",
  confirm_finalize_distribution: "Please note that finalising the distribution will publish the individual distribution reports to your members and you will no longer be able to change them. Would you like to proceed?",
  confirm_validate: "confirm validate",
  congratulations: "ขอแสดงความยินดี",
  continue: "ดำเนินการต่อ",
  create: "สร้าง",
  createNewSoundRecording: "สร้างสิ่งบันทึกเสียงใหม่",
  createPlaceholder: "สร้างข้อมูลทางเลือก",
  create_user: "สร้างผู้ใช้งาน",
  create_user_for: "สร้างผู้ใช้งานสำหรับ",
  created: "created",
  date: "วันที่",
  deduction_pct: "deduction %",
  defaultMatchingInfo: "By default, only the unmatched usages will be matched again.",
  delete: "ลบ",
  deleteClaims: "batch delete claims",
  delete_distribution: "Delete Distribution",
  delete_distribution_warning: "คุณแน่ใจที่จะลบข้อมูลการจัดสรรนี้หรือไม่",
  deleted: "deleted",
  dismiss: "ยกเลิก",
  distribution: "การจัดจำหน่าย",
  distribution_deleted: "ลบการจัดจำหน่าย",
  distribution_saved: "บันทึกการจัดจำหน่าย",
  distributions: "การจัดจำหน่าย",
  domestic: "ภายในประเทศ",
  download: "ดาวน์โหลด",
  downloadFile: "download file",
  downloadSampleFile: "ดาวน์โหลดไฟล์ตัวอย่าง",
  downloadSampleFileNote: "หมายเหตุ: ไฟล์ตัวอย่างขึ้นอยู่กับประเภทการใช้งานที่เลือก ไฟล์ที่ดาวน์โหลดก่อนหน้านี้ไม่สามารถใช้งานได้",
  downloadTemplate: "ดาวน์โหลดไฟล์เทมเพลต",
  duration: "ระยะเวลา",
  editClaim: "แก้ไขการอ้างสิทธิ์",
  editClaims: "batch edit claims",
  editDistribution: "edit distribution",
  editDistributionForFile: "ไฟล์ข้อมูลรายได้ที่ใช้ในการจัดจำหน่าย",
  edit_org: "แก้ไขข้อมูลบริษัท",
  email: "อีเมล์",
  email_format_not_valid: "อีเมล์ไม่อยู่ในรูปแบบที่ใช้งานได้",
  email_not_defined: "ไม่ได้กำหนดอีเมล",
  email_sent: "ส่งอีเมลแล้ว",
  error: "error",
  errors: "ข้อมูลผิดพลาด",
  exclude_members: "สมาชิกที่ยกเว้น",
  exclude_members_modal_header: "สมาชิกที่ยกเว้นจากไฟล์รายได้",
  exclude_members_modal_sub_text: "โดยปกติ SoundSys จะแจกจ่ายรายได้ให้กับทุกสมาชิกด้วยอาณัติ (Mandate) ที่ถูกต้อง หากบางสมาชิกมีใบอนุญาตโดยตรง หรือไม่ได้เข้าร่วมในไฟล์รายได้นี้ คุณสามารถยกเว้นได้ที่นี่ สมาชิกที่เลือกจะไม่ได้รับการจัดสรรจากไฟล์รายได้นี้",
  expired_session: "Your session has expired! Please login",
  extras: "เพิ่มเติม",
  field: "ช่อง",
  fileName: "ชื่อไฟล์",
  fileType: "file type",
  file_uploaded: "อัพเดทไฟล์เรียบร้อย!",
  filterFiles: "คัดกรองไฟล์ข้อมูล",
  filterSoundRecordings: "คัดกรองสิ่งบันทึกเสียง",
  filterTimePeriod: "ระยะเวลาการคัดกรอง (ไตรมาส)",
  filters: "กรองข้อมูล",
  finishSetup: "เสร็จสิ้นการตั้งค่า",
  fixation_country: "ประเทศที่บันทึกเสียง",
  fixation_year: "ปีที่เผยแพร่",
  forgot_your_password: "Forgot your password?",
  from: "จาก",
  funds: "ข้อมูลรายได้",
  generatePreDistributionReport: "generate pre distribution report",
  generateUnmatchedReport: "generate unmatched report",
  generatedReportWillBeSent: "generated report will be sent to you via email",
  genres: "genres",
  go_back: "กลับไป",
  go_to_users: "ไปยังชื่อผู้ใช้",
  gross_amount: "ยอดรวมก่อนหักค่าใช้จ่าย",
  hide: "hide",
  history: "history",
  ingested: "ingested",
  ingestionStats: "Ingestion Stats",
  invalid_data_range: "Invalid date range",
  invalid_split_range: "The split value should be in the range 0-100",
  invalid_split_value: "Invalid split value",
  invalid_time_format: "รูปแบบเวลาไม่ถูกต้อง",
  invalidateSource: "invalidate source",
  invalidateSourceInfo: "Warning. You are removing this instance data. It will no longer appear in the UI.",
  invalidatedSource: "source invalidated",
  isEligible: "มีคุณสมบัติเหมาะสม",
  isrc: "ISRC",
  item: "ไอเทม",
  landed: "landed",
  landed_sound_recordings: "landed sound recordings",
  lang_of_perf: "ภาษาที่ใช้",
  language: "ภาษา",
  licensee: "ผู้รับใบอนุญาต",
  linked: "linked",
  log_in: "log in",
  login: "login",
  logout: "ออกจากระบบ",
  makeAClaim: "สร้างการอ้างสิทธิ์",
  manually_created: "manually created",
  manually_linked: "manually linked",
  manually_matched: "manually matched",
  match: "match",
  matched: "matched",
  matchingStats: "Matching Stats",
  member: "สมาชิก",
  memberProfile: "ข้อมูลสมาชิก",
  memberSociety: "สมาชิก / สังกัด",
  member_not_defined: "องค์กรสมาชิกไม่มีการถูกกำหนด",
  member_saved: "บันทึกสมาชิก",
  members: "สมาชิก",
  missing_required_fields: "ไม่มีฟิลด์ตามที่กำหนด",
  myProfile: "ข้อมูลของฉัน",
  name: "ชื่อ",
  name_and_last_name: "ชื่อและนามสกุล",
  name_and_last_name_not_defined: "ชื่อและนามสกุล ไม่มีการถูกกำหนด",
  nationality: "สัญชาติ",
  net_amount: "จำนวนหลังหักค่าใช้จ่าย",
  newDistribution: "สร้างการจัดจำหน่าย",
  new_member_signup: "ลงทะเบียนสมาชิกใหม่",
  no: "ไม่",
  nothingToAdd: "Nothing to add",
  notifications: "การแจ้งเตือน",
  num_users: "จำนวนผู้ใช้งาน",
  optional: "ทางเลือก",
  orSelectCustomDateRange: "หรือเลือกช่วงเวลาที่กำหนดเอง",
  organization: "บริษัท",
  other_deductions_pct: "การหักส่วนอื่นๆ (%)",
  overclaimed: "overclaimed",
  password: "รหัสผ่าน",
  password_recovery: "กู้รหัสผ่าน",
  payee: "ผู้รับเงิน",
  pending: "pending",
  pending_for_validation: "pending for validation",
  people: "รายชื่อผู้ใช้งาน",
  period: "ระยะเวลา",
  placeholderSoundRecording: "This is a sound recording created from a usage log.",
  play_count: "จำนวนการเล่น",
  playlist_not_found: "Playlist file not found",
  playlist_rematching: "Playlist files re-matching",
  playlist_rematching_check: "Select this to re-match all playlist files included in this distribution.",
  playlist_rematching_desc: "By default the distribution engine will use current matching on all selected playlist files.",
  playlist_set_allocable: "เพลย์ลิสต์ตั้งค่าจัดสรรได้",
  playlist_will_be_matched_again: "เพลย์ลิสต์จะถูกจับคู่อีกครั้ง",
  playlists: "playlists",
  please_indicate_a_recovery_email: "โปรดระบุอีเมลเสำหรับกู้คืน",
  preDistributionWarning: "Only duration based playlist will be used for the pre-distribution report",
  processing: "processing",
  proposedCandidates: "เสนอข้อมูลทางเลือก",
  proprietary_id: "รหัสกรรมสิทธิ์ / อัปโหลดโดย",
  provider_id: "Provider id",
  re_allocate: "ดำเนินการจัดสรรอีกครั้ง",
  readyForDistribution: "พร้อมสำหรับการจัดจำหน่าย",
  reason: "เหตุผล",
  recording_unclaimed: "ไม่มีการอ้างสิทธิ์การบันทึก",
  regitry_line_1: "การสมัครของคุณจะได้รับการตรวจสอบ",
  regitry_line_2: "เมื่อผ่านการอนุมัติ คุณจะได้รับอีเมลเพื่อตั้งค่ารหัสผ่านของคุณ",
  regitry_line_3: "โปรดรอ",
  regitry_line_4: "ท่านจะได้รับการติดต่อกลับจากเราเร็วๆนี้",
  releaseNames: "ชื่ออัลบั้ม",
  remove: "เอาออก",
  removeAllClaimsQuestion: "คุณต้องการลบข้อมูลสิ่งบันทึกเสียงทั้งหมดจากรายการการอ้างสิทธิ์ ใช่หรือไม่",
  removeClaim: "ลบการอ้างสิทธิ์",
  remove_all: "นำข้อมูลทั้งหมดออกจากพื้นที่อ้างสิทธิ์",
  repertoire: "repertoire",
  rightOwner: "เจ้าของลิขสิทธิ์",
  rightOwners: "right owners",
  rightPeriod: "ระยะเวลาลิขสิทธิ์",
  rightTypes: "ประเภทลิขสิทธิ์",
  rights: "ลิขสิทธิ์",
  rule: "rule",
  save: "บันทึก",
  saveAsDraft: "บันทึกเป็นแบบร่าง",
  save_member: "Save Member",
  save_member_warning: "การเปลี่ยนอาณัติ (mandate) / ประเภทการใช้งาน (use-types) สำหรับสมาชิกนี้ ระบบจะอัปเดตการอ้างสิทธิ์ที่มีอยู่ การเปลี่ยนแปลงเหล่านี้อาจใช้เวลา 2 - 3 ชั่วโมงจึงจะมีผลกับฐานข้อมูล คุณแน่ใจหรือไม่?",
  search: "search",
  search_candidates: "search candidates",
  select: "เลือก",
  selectFileType: "Select File Type",
  selectFunds: "เลือกรายได้",
  selectMember: "เลือก สมาชิก",
  selectPayee: "เลือก ผู้รับเงิน",
  selectPlaylists: "เลือก เพลย์ลิสต์",
  selectRightOwner: "เลือก เจ้าของลิขสิทธิ์",
  selectRightTypes: "เลือก ประเภทลิขสิทธิ์",
  selectRule: "select rule",
  selectStatus: "เลือกสถานะ",
  selectUseType: "เลือกประเภทการใช้งาน",
  select_all: "select all",
  select_date: "เลือกวันที่/เดือน/ปี",
  select_date_range: "เลือกวันที่/เดือน/ปี",
  select_member: "เลือกสมาชิก",
  select_members: "Select members",
  select_members_to_participate: "Select members to participate",
  select_type: "เลือกประเภท",
  send: "ส่ง",
  send_notifications: "send notifications",
  setupNewDistribution: "สร้างการจัดจำหน่ายรายได้",
  show: "show",
  showIneligible: "แสดงสถานะความเหมาะสม",
  show_hidden: "show hidden",
  show_inactive: "แสดงข้อมูลที่ไม่ทำงาน",
  sign_up: "ลงชื่อเข้าระบบ",
  signup_header: "กรอกรายละเอียดของคุณ บัญชีจะถูกตรวจสอบก่อนที่จะสร้าง",
  society: "องค์กรจัดเก็บลิขสิทธิ์",
  soundRecordingDetail: "รายละเอียดการบันทึกเสียง",
  soundRecordingDetails: "รายละเอียดการบันทึกเสียง",
  soundRecordings: "สิ่งบันทึกเสียง",
  soundSysDatabase: "ฐานข้อมูล Soundsys",
  sound_recording_saved: "บันทึกสิ่งบันทึกเสียง",
  sound_recordings_claimed: "อ้างสิทธิ์สิ่งบันทึกเสียง",
  soundrecordingDetail: "รายละเอียดสิ่งบันทึกเสียง",
  source: "source",
  sourceMetadata: "แหล่งที่มาของ Metadata",
  split: "ส่วนแบ่ง",
  status: "สถานะ",
  submittedBy: "นำเข้าระบบโดย",
  tax_deductions_pct: "หักภาษี ณ ที่จ่าย (%)",
  this_user_will_receive_all_notifications: "this user will receive all notifications",
  this_user_will_receive_no_notifications: "this user will receive no notifications",
  time_period: "ระยะเวลา",
  title: "ชื่อเพลง",
  to: "ถึง",
  total: "total",
  total_unique: "total unique",
  type: "ประเภท",
  un_select_all: "เลือกทีละเพลง/เลือกทั้งหมด",
  unclaimed: "unclaimed",
  underclaimed: "underclaimed",
  unmatched: "unmatched",
  unmatched_no_duplicates: "unmatched no duplicates",
  unmatched_ready_for_distribution: "unmatched ready for distribution",
  upload: "อัพโหลด",
  uploadDate: "วันที่อัพโหลด",
  uploadFunds: "อัพโหลดไฟล์รายได้",
  uploadProRataFile: "อัปโหลด Pro Rata ไฟล์",
  uploads: "อัปโหลด",
  usageType: "รูปแบบการใช้งาน",
  usages: "การใช้งาน",
  useReleaseMatchingInfo: "Force using Album info while matching. WARNING: This could create false positives",
  useType: "ประเภทการใช้งาน",
  userProfile: "ประวัติผู้ใช้งาน",
  user_data: "ข้อมูลผู้ใช้งาน",
  user_saved: "บันทึกผู้ใช้งาน",
  user_type_not_defined: "ไม่ได้กำหนดประเภทผู้ใช้",
  username: "ชื่อผู้ใช้งาน",
  users: "ผู้ใช้งาน",
  validate: "ทำให้สมบูรณ์",
  value: "มูลค่า",
  version: "version",
  versionTitle: "ชื่อเวอร์ชั่น",
  view: "view",
  view_excluded_members: "View Excluded Members",
  view_selected_members: "view selected members",
  view_selected_playlists: "ดูเพลย์ลิสต์ที่เลือกไว้",
  worldwide: "ทั่วโลก",
  year: "ปี",
  yes: "ใช่",
}
